/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:767px){[_nghost-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{margin:auto;position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-settings/achoo-modal/achoo-modal.component.scss.shim.ngstyle.js.pre-build-optimizer.js